import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/i18n";

import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Buy from "./pages/Buy";
import Rent from "./pages/Rent";
import Projects from "./pages/Projects";
import PropertyDetail from "./pages/PropertyDetail";
import ProjectDetail from "./pages/ProjectDetail";
import Dashboard from "./pages/Dashboard";
import DeveloperApplication from "./pages/DeveloperApplication";
import AgencyApplication from "./pages/AgencyApplication";
import MortgageCalculator from "./pages/MortgageCalculator";
import CostCalculator from "./pages/CostCalculator";
import Agencies from "./pages/Agencies";
import AgencyDetail from "./pages/AgencyDetail";
import Plots from "./pages/Plots";
import PlotDetail from "./pages/PlotDetail";
import Commercial from "./pages/Commercial";
import CommercialDetail from "./pages/CommercialDetail";
import Advertise from "./pages/Advertise";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/rent" element={<Rent />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/agencies" element={<Agencies />} />
            <Route path="/agencies/:id" element={<AgencyDetail />} />
            <Route path="/property/:id" element={<PropertyDetail />} />
            <Route path="/developer-application" element={<DeveloperApplication />} />
            <Route path="/agency-application" element={<AgencyApplication />} />
            <Route path="/plots" element={<Plots />} />
            <Route path="/plot/:id" element={<PlotDetail />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/commercial/:id" element={<CommercialDetail />} />
            <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
            <Route path="/cost-calculator" element={<CostCalculator />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
